"use client";
// import { Logo } from "../../design1/components/HeroSearchComponent";
import Link from "next/link";
import { useState } from "react";
import { usePathname } from "next/navigation";
import { HoverList } from "../../design2/NavBar";
import { navLinks } from "src/app/components/constants/navlink";
import { CompanyLogo, Hamburger } from "../../design1/NavBar";
import { Sidebar } from "../../design1/NavBar";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import { useFetchValidSocialMediaLinks } from "src/app/lib/useFetcchValidSocialMediaLinks";
import { Config } from "src/types";
import { getPageVisibilityClass } from "../../design1/Footer";

const NavBar3 = () => {
  const [open, setOpen] = useState(false);
  const { data: config } = useFetchCompanyInfo();
  const { socialMediaLinks } = useFetchValidSocialMediaLinks();

  return (
    <>
      <Sidebar
        variant
        setOpen={setOpen}
        open={open}
        navLinks={navLinks}
        config={config}
        socials={socialMediaLinks}
      />
      <nav className="py-3 shadow-sm bg-white z-[40] fixed top-0 w-full left-0 text-white">
        <div className="wrapper flex items-center justify-between">
          <Link href="/">
            <header className="">
              <CompanyLogo />
            </header>
          </Link>
          <NavItems config={config as Config} />
          <div title="Click to Login" className="flex items-center gap-6">
            <Link href={"https://app.ourproperty.com.ng/auth/user/sign-in"}>
              <PersonIcon />
            </Link>
            <Hamburger open={open} setOpen={setOpen} />
          </div>
        </div>
      </nav>
    </>
  );
};
export default NavBar3;

export const NavItems: React.FC<{ config: Config }> = ({ config }) => {
  const pathname = usePathname();
  const [openSub, setOpenSub] = useState(false);

  return (
    <ul className="flex xlg:hidden gap-8 items-center">
      {navLinks.map((item, index) => {
        const isActive =
          pathname === item.link || // Exact match
          (item.link === "/properties" && pathname.startsWith("/properties/"));
        return (
          <li
            onMouseEnter={() => {
              if (item.link === "/properties") {
                setOpenSub(true);
              }
            }}
            onMouseLeave={() => {
              if (item.link === "/properties") {
                setOpenSub(false);
              }
            }}
            className={`group ${getPageVisibilityClass(
              item.link,
              config,
              "!hidden"
            )} transition-all duration-500 p-1 relative hover:bg-[rgba(var(--primary-color-rgb),0.1)] text-secondary-main pb- hover:text-themeColor ${
              isActive
                ? "font-bold bg-[rgba(var(--primary-color-rgb),0.1)] text-themeColor"
                : ""
            }`}
            key={index}
          >
            <div
              className={`absolute h-[4px] transition-all duration-500 right-0 w-full bg-transparent group-hover:bg-themeColor ${
                isActive && "!bg-themeColor"
              }  bottom-0 rounded-full`}
            ></div>
            <Link className="group" href={item.link}>
              {openSub && item.link === "/properties" && (
                <HoverList className="!top-[100%]" setOpen={setOpenSub} />
              )}
              {item.name}
            </Link>
            {/* <div className="absolute invisible group-hover:visible size-[0.5rem] left-1/2 rounded-full bg-themeColor"></div> */}
          </li>
        );
      })}
    </ul>
  );
};

export const PersonIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="var(--primary-color)" />
      <path
        d="M20 12C21.0609 12 22.0783 12.4214 22.8284 13.1716C23.5786 13.9217 24 14.9391 24 16C24 17.0609 23.5786 18.0783 22.8284 18.8284C22.0783 19.5786 21.0609 20 20 20C18.9391 20 17.9217 19.5786 17.1716 18.8284C16.4214 18.0783 16 17.0609 16 16C16 14.9391 16.4214 13.9217 17.1716 13.1716C17.9217 12.4214 18.9391 12 20 12ZM20 28C20 28 28 28 28 26C28 23.6 24.1 21 20 21C15.9 21 12 23.6 12 26C12 28 20 28 20 28Z"
        fill="white"
      />
    </svg>
  );
};
